import { type InfiniteData, type QueryClient } from 'react-query'

import { type IInfinitePage } from 'types/interfaces/ITypes'

const updatePostTipAmountCache = async (
    postId: string,
    dataQuery: any,
    queryClient: QueryClient,
    tipAmount: number
) => {
    await queryClient.cancelQueries({ queryKey: dataQuery })

    const cachedData =
        queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery)

    if (cachedData) {
        const newData = {
            ...cachedData,
            pages: cachedData.pages.map(singleFeedPage => {
                return {
                    ...singleFeedPage,
                    page: {
                        ...singleFeedPage.page,
                        data: {
                            ...singleFeedPage.page.data,
                            data: singleFeedPage.page.data.data.map(post =>
                                post.goal && post.id === postId
                                    ? {
                                          ...post,
                                          goal: {
                                              ...post.goal,
                                              tipped:
                                                  post.goal?.tipped + tipAmount
                                          }
                                      }
                                    : post
                            )
                        }
                    }
                }
            })
        }

        queryClient.setQueryData(dataQuery, newData)
    }
}

export { updatePostTipAmountCache }
